import { render } from "./BusinessReports.vue?vue&type=template&id=ae782876&scoped=true"
import script from "./BusinessReports.vue?vue&type=script&lang=js"
export * from "./BusinessReports.vue?vue&type=script&lang=js"

import "./BusinessReports.vue?vue&type=style&index=0&id=ae782876&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae782876"]])

export default __exports__